// Gera a escala de cor "brand" (25..950, mesmos tons que o Tailwind usa pro
// app inteiro) a partir de UM hex — a cor do partido do candidato logado —
// e sobrescreve as custom properties CSS que o Tailwind v4 usa por baixo dos
// panos (bg-brand-500 etc já compilam pra var(--color-brand-500)), então
// aplicar aqui retema o site inteiro sem precisar recompilar nada.
//
// ponytail: curva de luminosidade fixa por percentual, não uma cópia exata
// da curva original — funciona bem pra qualquer hex de entrada, mas não é
// "a" curva perceptualmente ideal. Trocar por um algoritmo de geração de
// paleta (ex: culori) se algum partido específico ficar com contraste ruim.
const PONTOS_CLAROS = { 25: 0.97, 50: 0.95, 100: 0.9, 200: 0.8, 300: 0.68, 400: 0.55 };

function hexParaHsl(hex) {
  const m = hex.replace('#', '');
  const r = parseInt(m.slice(0, 2), 16) / 255;
  const g = parseInt(m.slice(2, 4), 16) / 255;
  const b = parseInt(m.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return { h, s, l };
}

function hslParaHex({ h, s, l }) {
  const paraCor = (p, q, t) => {
    let tt = t;
    if (tt < 0) tt += 1;
    if (tt > 1) tt -= 1;
    if (tt < 1 / 6) return p + (q - p) * 6 * tt;
    if (tt < 1 / 2) return q;
    if (tt < 2 / 3) return p + (q - p) * (2 / 3 - tt) * 6;
    return p;
  };
  let r, g, b;
  if (s === 0) {
    r = g = b = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = paraCor(p, q, h + 1 / 3);
    g = paraCor(p, q, h);
    b = paraCor(p, q, h - 1 / 3);
  }
  const paraHex = (v) => Math.round(v * 255).toString(16).padStart(2, '0');
  return `#${paraHex(r)}${paraHex(g)}${paraHex(b)}`;
}

const STOPS = [25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

// hexBase null/undefined = volta ao azul padrão do template (remove o override).
export function aplicarTemaPartido(hexBase) {
  const raiz = document.documentElement;
  if (!hexBase) {
    STOPS.forEach((s) => raiz.style.removeProperty(`--color-brand-${s}`));
    return;
  }
  const { h, s } = hexParaHsl(hexBase);
  const l500 = Math.min(Math.max(hexParaHsl(hexBase).l, 0.4), 0.55);
  const luminosidade = {
    ...PONTOS_CLAROS,
    500: l500,
    600: Math.max(l500 - 0.1, 0.2),
    700: Math.max(l500 - 0.18, 0.15),
    800: Math.max(l500 - 0.25, 0.12),
    900: Math.max(l500 - 0.32, 0.1),
    950: Math.max(l500 - 0.4, 0.06),
  };
  STOPS.forEach((stop) => {
    raiz.style.setProperty(`--color-brand-${stop}`, hslParaHex({ h, s, l: luminosidade[stop] }));
  });
}
